import React from "react";
import { KPI_KEYS } from "../utils/calendarUtils";

const GoalModal = ({ isOpen, onClose, modalValues, setModalValues, onSubmit, originalKpis, selectedDate }) => {
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  const getOriginalValue = (kpi) => {
    // For PR/TR and PP/TP, display as "numerator/denominator"
    if (kpi === "PR/TR" || kpi === "PP/TP") {
      const value = originalKpis?.[kpi] || "0/0";
      return typeof value === 'string' ? value : "0/0";
    }
    return originalKpis?.[kpi] || 0;
  };

  const parseRatio = (value) => {
    if (typeof value === 'string' && value.includes('/')) {
      const [num, den] = value.split('/').map(v => parseInt(v) || 0);
      return { numerator: num, denominator: den };
    }
    return { numerator: 0, denominator: 0 };
  };

  const getCurrentRatio = (kpi) => {
    const value = modalValues[kpi] || "0/0";
    return parseRatio(value);
  };

  const updateRatio = (kpi, part, value) => {
    const current = getCurrentRatio(kpi);
    const num = part === 'numerator' ? (parseInt(value) || 0) : current.numerator;
    const den = part === 'denominator' ? (parseInt(value) || 0) : current.denominator;
    setModalValues({
      ...modalValues,
      [kpi]: `${num}/${den}`
    });
  };

  const getMonthYearString = () => {
    if (!selectedDate) return "This Month";
    const months = ["January", "February", "March", "April", "May", "June", 
                   "July", "August", "September", "October", "November", "December"];
    return `${months[selectedDate.getMonth()]} ${selectedDate.getFullYear()}`;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content goal-modal" onClick={(e) => e.stopPropagation()}>
        <div className="goal-modal-header">
          <h3>TO DO: {getMonthYearString()}</h3>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="goal-edit-grid-new">
            {/* Header Row */}
            <div className="goal-row goal-header-row">
              <div className="goal-col goal-label-col">ORIGINAL</div>
              <div className="goal-col goal-kpi-col"></div>
              <div className="goal-col goal-input-col">CHANGE TO</div>
            </div>

            {/* Data Rows */}
            {KPI_KEYS.map((kpi) => (
              <div key={kpi} className="goal-row">
                <div className="goal-col goal-original-value">
                  {getOriginalValue(kpi)}
                </div>
                <div className="goal-col goal-kpi-label">{kpi}</div>
                <div className="goal-col goal-new-value">
                  {kpi === "PR/TR" || kpi === "PP/TP" ? (
                    <div className="ratio-input-group">
                      <input
                        type="number"
                        value={getCurrentRatio(kpi).numerator}
                        onChange={(e) => updateRatio(kpi, 'numerator', e.target.value)}
                        placeholder="0"
                        className="goal-input ratio-input"
                        min="0"
                      />
                      <span className="ratio-separator">/</span>
                      <input
                        type="number"
                        value={getCurrentRatio(kpi).denominator}
                        onChange={(e) => updateRatio(kpi, 'denominator', e.target.value)}
                        placeholder="0"
                        className="goal-input ratio-input"
                        min="0"
                      />
                    </div>
                  ) : (
                    <div className="goal-input-wrapper">
                      {kpi === 'SAV' || kpi === 'CF' ? <span className="currency-symbol">$</span> : null}
                      <input
                        type="number"
                        value={modalValues[kpi] || 0}
                        onChange={(e) => setModalValues({
                          ...modalValues,
                          [kpi]: parseInt(e.target.value) || 0
                        })}
                        className="goal-input"
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="goal-modal-actions">
            <button type="submit" className="btn-submit-goal">
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default GoalModal;